const routes = [
    {
        path: "/exchangestudent/application/form",
        component: () => import("../pages/ApplicationForm")
    },
    {
        path: "/exchangestudent/application/login",
        component: () => import("../pages/Login")
    },
    {
        path: "/exchangestudent/application/register",
        component: () => import("../pages/Register")
    },
    {
        path: "/exchangestudent/application/forgot/password",
        component: () => import("../pages/ForgotPassword")
    },
    /// Admin
   /* {
        path: "/exchangestudent/applications",
        component: () => import("../pages/admin/Index"),
        meta: {
            isAuthenticated: true,
            permission: ''
        }
    },*/

];

export default routes;
